import { useTranslationLanguageWithoutRegion } from './useTranslationLanguageWithoutRegion';
import type { OrderItem } from 'store/Orders/types';

const INTERNAL = 'internal' as const;

type UseItemDisplayNameArgs = {
  itemDisplayName: OrderItem['display_names'];
};

export function useItemDisplayName(): {
  getItemDisplayName: ReturnType<typeof getItemDisplayName>;
};
export function useItemDisplayName(args: UseItemDisplayNameArgs): {
  itemDisplayName: string | undefined;
};
export function useItemDisplayName(args?: UseItemDisplayNameArgs) {
  const { lang } = useTranslationLanguageWithoutRegion();

  if (!args) {
    return {
      getItemDisplayName: getItemDisplayName({ lang }),
    };
  }
  const itemDisplayName = getItemDisplayName({ lang })(args.itemDisplayName);

  return {
    itemDisplayName,
  };
}

export const getItemDisplayName =
  (dep: { lang: string }) => (itemDisplayName: OrderItem['display_names']) => {
    return itemDisplayName?.[INTERNAL]?.[dep.lang];
  };
